// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { usePendingIncomingPayment, getGatewayVoucherCode } from '@tectonics/prs/incoming-payment';
import { timesGroupSplitter } from '@tectonics/look-and-feel/commons/format-utils';
import { ButtonPrintVoucher } from './button-print-voucher';
import { ButtonSaveVoucher } from './button-save-voucher';

export function DisplayEfectyVoucherCode(): Node {
  const incomingPayment = usePendingIncomingPayment();

  return (
    <Root data-test-id="ticket-code">
      <Term>Datos para pago</Term>
      <Caption>Dicta la siguiente referencia al cajero para realizar tu pago:</Caption>
      <Definition>
        {timesGroupSplitter(4, getGatewayVoucherCode(incomingPayment)).map((code, index) => (
          <NumberGroup key={index}>{code}</NumberGroup>
        ))}
      </Definition>
      <ButtonsWrapper>
        <ButtonPrintVoucher />
        <ButtonSaveVoucher />
      </ButtonsWrapper>
    </Root>
  );
}

const Root = styled.div`
  text-align: center;
`;

const Term = styled.div`
  font-weight: bold;
`;

const Caption = styled.p`
  font-size: 0.9em;
  margin: 0.5em 0;
`;

const Definition = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 1.5em;
`;

const NumberGroup = styled.strong`
  margin: 0.2em;
  padding: 0.1em 0.4em;

  font-size: 1.3em;
  text-align: center;

  background-color: ${props => props.theme.colors.gray[1]};
  border-radius: 5px;
`;

const ButtonsWrapper = styled.div`
  margin-top: 1.8em;
  @media (min-width: 990px) {
    display: flex;
  }
`;
